export default "__VITE_ASSET__DfVb4$Gp__"